import React from "react";
import { IAccountContext } from "./types";

/**
 * Sentinel default value used to detect hook misuse.
 *
 * The provider always supplies a freshly memoized object, so a strict
 * reference equality check (`ctx === DEFAULT_ACCOUNT_CONTEXT`) in
 * {@link useAccountContext} reliably identifies when no provider is in the tree.
 */
export const DEFAULT_ACCOUNT_CONTEXT: IAccountContext = {
  contextId: null,
  setContextId: () => undefined,
  clearAccountContext: () => undefined,
};

/**
 * React context for the active account context selection.
 *
 * Do not consume this directly — use {@link useAccountContext} instead,
 * which validates the provider is present and returns a typed value.
 */
export const AccountContext = React.createContext<IAccountContext>(DEFAULT_ACCOUNT_CONTEXT);

export default AccountContext;
